import { render, staticRenderFns } from "./ElementsLinkModal.vue?vue&type=template&id=4f0e7b41&scoped=true"
import script from "./ElementsLinkModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ElementsLinkModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ElementsLinkModal.vue?vue&type=style&index=0&id=4f0e7b41&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0e7b41",
  null
  
)

export default component.exports